import { setDirtyForm } from 'app/actions/dirty-forms.actions';
import { deleteAnnouncement, togglePinAnnouncements } from 'dashboard/actions/announcements/announcements.actions';

import template from './announcement-list.html';

const DIRTY_FORM = 'announcementsManagement';

const mapStateToThis = ({ dirtyForms, ui }) => {
  const dirtyForm = dirtyForms[DIRTY_FORM];
  const { selectedLanguage } = ui;

  return {
    dirtyForm,
    selectedLanguage,
  };
};

const mapDispatchToThis = {
  setDirtyForm,
  deleteAnnouncement,
  togglePinAnnouncements,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', '$state')
class AnnouncementListController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
    this.DIRTY_FORM = DIRTY_FORM;
  }

  $onDestroy() {
    this.unsubscribe();
  }

  onEditAnnouncement(index) {
    this.$state.go('cms-editNewsManagement', {
      id: index,
      type: this.type,
      skipDirtyForms: true,
    });
  }

  onPinAnnouncement(index) {
    this.togglePinAnnouncements(index);
    this.setDirtyForm(DIRTY_FORM, true);
  }

  onDeleteAnnouncement(index) {
    this.deleteAnnouncement(index, this.type);
    this.setDirtyForm(DIRTY_FORM, true);
  }
}

export default class AnnouncementListComponent {
  constructor() {
    this.controller = AnnouncementListController;
    this.template = template;
    this.bindings = {
      announcements: '<',
      type: '<',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/announcements/components/announcement-list/announcement-list-component.js